import React from "react";
import { CheckCircle, XCircle, Clock } from "lucide-react";
import { Button } from "../ui/button";

export function TicketApprovalBanner({ approval, onDecide, isAssistant = false, managerName = "" }) {
    if (!approval) return null;
    return (
        <div
            className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6 flex items-center justify-between"
            data-testid="approval-banner"
        >
            <div>
                <p className="font-medium text-yellow-800">
                    {isAssistant
                        ? "Ce ticket nécessite l'approbation du responsable"
                        : "Ce ticket nécessite votre approbation"}
                </p>
                <p className="text-sm text-yellow-600">
                    Étape {approval.step_order} du processus d'approbation
                </p>
                {isAssistant && managerName && (
                    <p className="text-xs text-yellow-700 mt-1 font-medium" data-testid="assistant-info">
                        Vous approuvez au nom de {managerName}
                    </p>
                )}
            </div>
            <div className="flex items-center gap-2">
                <Button
                    variant="outline"
                    onClick={() => onDecide(approval.id, "rejected")}
                    data-testid="reject-btn"
                >
                    <XCircle className="w-4 h-4 mr-2" />
                    Rejeter
                </Button>
                <Button
                    onClick={() => onDecide(approval.id, "approved")}
                    data-testid="approve-btn"
                >
                    <CheckCircle className="w-4 h-4 mr-2" />
                    Approuver
                </Button>
            </div>
        </div>
    );
}

export function TicketApprovalsSidebar({ approvals, getUserById }) {
    if (!approvals || approvals.length === 0) return null;
    return (
        <div className="card">
            <div className="card-header">
                <h3 className="text-sm font-semibold">Approbations</h3>
            </div>
            <div className="card-body">
                <div className="space-y-3">
                    {approvals.map((approval) => {
                        const approver = getUserById(approval.approver_id);
                        const decidedByUser = approval.decided_by ? getUserById(approval.decided_by) : null;
                        const onBehalfOf = approval.decided_on_behalf_of ? getUserById(approval.decided_on_behalf_of) : null;
                        return (
                            <div
                                key={approval.id}
                                className="flex items-start gap-3"
                                data-testid={`approval-${approval.id}`}
                            >
                                <div
                                    className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 ${
                                        approval.status === "approved"
                                            ? "bg-green-100 text-green-600"
                                            : approval.status === "rejected"
                                            ? "bg-red-100 text-red-600"
                                            : "bg-gray-100 text-gray-400"
                                    }`}
                                >
                                    {approval.status === "approved" ? (
                                        <CheckCircle className="w-4 h-4" />
                                    ) : approval.status === "rejected" ? (
                                        <XCircle className="w-4 h-4" />
                                    ) : (
                                        <Clock className="w-4 h-4" />
                                    )}
                                </div>
                                <div className="flex-1 min-w-0">
                                    <p className="text-sm font-medium truncate">
                                        {approver?.first_name} {approver?.last_name}
                                    </p>
                                    <p className="text-xs text-gray-500">
                                        Étape {approval.step_order}
                                    </p>
                                    {decidedByUser && onBehalfOf && decidedByUser.id !== onBehalfOf.id && (
                                        <p className="text-[10px] text-indigo-600 mt-0.5" data-testid={`approval-behalf-${approval.id}`}>
                                            {approval.status === "approved" ? "Approuvé" : "Refusé"} par {decidedByUser.first_name} {decidedByUser.last_name} au nom de {onBehalfOf.first_name} {onBehalfOf.last_name}
                                        </p>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
